<template>
  <div v-if="mode == 'view'" style="margin-left: 10px"> {{ model.displayName }}</div>
  <!-- <el-input v-if="mode != 'view'" v-model="model.displayName">
    <template #append>
      <el-button type="primary" icon="el-icon-search" @click="model.visible = true"></el-button>
    </template>
  </el-input> -->
  <el-autocomplete
    v-if="mode != 'view'"
    :fetch-suggestions="querySearchAsync"
    v-model="model.displayName"
    value-key="enterpriseName"
    style="width: 100%"
    @select="selectEnterprise"
  >
    <template #append>
      <el-button type="primary" icon="el-icon-search" @click="model.visible = true"></el-button>
    </template>
  </el-autocomplete>
  <td-dialog
    title="企业信息选择"
    icon="el-icon-search"
    :show-full-screen="false"
    fullscreen
    v-model="model.visible"
    no-ok-button
    no-padding
    no-scrollbar
    cancelText="关闭"
  >
    <td-list
      ref="listRef"
      v-model:query-model="model.list.queryModel"
      v-model:data="model.list.data"
      :cols="cols"
      :open-toosl-bar="false"
      fixed
      :action="model.list.action"
    >
      <template #querybar>
        <el-form-item label="企业名称：" prop="enterpriseName">
          <el-input v-model="model.list.queryModel.enterpriseName"></el-input>
        </el-form-item>
      </template>
      <template #col-button-choice="{ row }">
        <el-button type="text" icon="el-icon-select" @click="selectEnterprise(row)">选择</el-button>
      </template>
    </td-list>
  </td-dialog>
</template>

<script setup>
import { reactive, ref, watchPostEffect, onUnmounted } from 'vue'
import { getList, detail } from '../../../api/archive'

const props = defineProps({
  modelValue: {
    type: [Object, String, Number, Array],
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  },
  //传入对象时企业名称
  labelStr: {
    type: String,
    default: 'enterpriseName'
  },
  //传入对象时id
  idStr: {
    type: String,
    default: 'id'
  },
  /**是否多选 */
  multiple: {
    type: Boolean,
    default: false
  },
  /**行政区划 */
  areaCode: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: 'edit'
  },
  manageLevel: {
    type: String,
    default: ''
  },
  supervisionTypes: {
    type: [String, Number],
    default: ''
  },
  size: {
    type: Number,
    default: 5
  }
})
const model = reactive({
  displayName: '',
  name: {},
  visible: false,
  /**列表页模型 */
  list: {
    queryModel: {},
    data: [],
    action: {
      query: getList
    }
  }
})
const emit = defineEmits(['update:modelValue', 'update:visible', 'change'])
const cols = reactive([
  {
    label: '企业名称',
    prop: 'enterpriseName',
    align: 'center'
  },
  {
    label: '统一社会信用代码',
    prop: 'socialCreditCode',
    width: 220,
    align: 'center'
  },
  {
    label: '法人代表',
    prop: 'legalRepresentative',
    width: 100,
    align: 'center'
  },
  {
    label: '单位地址',
    prop: 'litigantManAddress',
    align: 'center'
  },
  {
    type: 'buttons',
    label: '操作',
    buttons: ['choice'],
    width: 80,
    align: 'center'
  }
])
const listRef = ref(null)
const selectEnterprise = row => {
  model.displayName = row.enterpriseName
  model.visible = false
  row.unitAdrees = row.litigantManAddress
  row.environmentalPerson = row.legalRepresentative

  emit('update:modelValue', row.id)
  emit('change', row)
}

const querySearchAsync = async (keyWord, callback) => {
  if (keyWord == '') {
    callback([])
    return
  }
  let result = await getList({ enterpriseName: keyWord })
  if (result.code == 200) {
    if (result.data.records.length == 1) {
      callback(result.data.records)
    } else {
      callback(result.data.records)
    }
  } else {
    callback([])
  }
}
const stop = watchPostEffect(() => {
  if (props.modelValue) {
    detail(props.modelValue).then(result => {
      if (result.code == 200) {
        model.displayName = result.data.enterpriseName
      }
    })
  }
})
onUnmounted(() => {
  stop()
})
</script>
<script>
export default {
  name: 'ArchiveList',
  cname: '企业信息选择', //启用企业档案模块时关闭 删除这个
  viewDisplay: true
}
</script>
